var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12 5H7V0H5v5H0v2h5v5h2V7h5V5z","fill":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }